module.exports = __webpack_public_path__ + "static/media/salesman.7b61713d.png";